import { makeStyles } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tab,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import axios from "axios";
import b64toBlob from "b64-to-blob";
import isoCountries from "i18n-iso-countries";
import jwt_decode from "jwt-decode";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useDymoCheckService, useDymoFetchPrinters } from "react-dymo-hooks";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import cameraIcon from "../../assets/cameraIcon.svg";
import errorIcon from "../../assets/USA_Images/offenderError.svg";
import successIcon from "../../assets/USA_Images/offenderSuccess.svg";
import CustomDateTimePicker from "../../components/CustomInputs/CustomDateTimePicker";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import { WebcamCapture } from "../../components/CustomInputs/WebCam";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import VisitorAssetsDialog from "../../components/DialogBoxComponent/VisitorAssetsDialog";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import httpCommon from "../../config/http-common";
import { getListSettings } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import { getCompanyInfo } from "../../slices/Company/CompanySlice";
import { getEmployeeNotificationDetails } from "../../slices/Employee/EmployeeSlice";
import { listHost } from "../../slices/HostSlice";
import { createInvitation } from "../../slices/Invitations/InvitationsSlice";
import { getPurposeType } from "../../slices/PurposeTypeGlobalUSA/PurposeTypeGlobalSlice";
import { getAllSites } from "../../slices/Site/SiteSlice";
import { customerSubscription } from "../../slices/Subscription/SubscriptionSlice";
import { getUserInfoPro } from "../../slices/User/UserSlice1";
import {
  deteleAssetImage,
  uploadVisitorAsset,
  validateVisitorImage,
} from "../../slices/VisitorDocuments/VisitorDocumentSlice";
import { getAllVisitorType } from "../../slices/VisitorType/VisitorTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomPhones from "../OnBoardV2/CustomPhones";
import Offender from "./Offender";
import "./phoneInput.css";
import UploadDocs from "./UploadDocs";

const Dymo = require("dymojs"),
  dymo = new Dymo();
const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .css-ypiqx9-MuiDialogContent-root": {
      padding: "0px !important",
    },
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
}));

export default function CreateNewRegistration(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [testImage, setTestImage] = useState("");
  const [siteData, setSiteData] = useState([]);
  const [data, setData] = useState();
  const [hostList, setHostList] = useState([]);
  const [selectedHost, setSelectHost] = useState({});
  const classes = useStyles();
  const [InavalidprofilePhoto, setInavalidprofilePhoto] = useState(false);
  const [visitorData, setVisitorData] = useState([]);
  const [purposeData, setPurposeData] = useState([]);
  const [phoneInput, setPhoneInput] = useState("");
  const [profileImage, setProfileImage] = useState();
  var minutes =
    props.walkInIntervalTime === "" ? 30 : Number(props.walkInIntervalTime);
  const [walkInIntervalTime, setWalkInIntervalTime] = useState(minutes);
  const [printerImage, setPrinterImage] = useState("");
  const [str, setStr] = useState("");
  const [documentScanMode, setDocumentScanMode] = useState("");
  const [dlImage, setdlImage] = useState();
  const [changeDate, setDateChange] = useState(true);
  const [userPhone, setUserPhone] = useState("");
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const [dlScannerPermission, setDlScannerPermission] = useState(false);
  const [featureList, setFeatureList] = useState([]);
  const [webCam, setWebCam] = useState(false);
  const [asssetImageIcon, setAssetImageIcon] = useState(props.walkImageCapture);
  const [assetuploadData, setAssetUploadData] = useState({});
  const [assetsImages, setAssetsImages] = useState([]);
  const [country, setCountry] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [objectKeys, setObjectKeys] = useState([]);
  const [walkInImageCapture, setWalkInImageCapture] = useState(false);
  const [autoContactInfo, setAutoContactIfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [offenderFeature, setOffenderFeature] = useState(false);
  const { darkMode } = useContext(ThemeContext);
  const [defaultHostId, setDefaultHostId] = useState("");
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));
  const [searchTerm, setSearchTerm] = useState("");
  const [offenderVerification, setOffenderVerification] = useState(
    companySettings.offenderVerification,
  );
  const [documentCapturePermission, setDocumentCapturePersmission] = useState(
    companySettings.documentCapture,
  );
  const [siteTimeEnable, setSiteTimeEnable] = useState(true);
  const [siteCurrentDateTime, setSiteCurrentDateTime] = useState(null);
  const [
    isDrivingLicenseEnabledForAdmin,
    setIsDrivingLicenseEnabledForAdmin,
  ] = useState(false);
  const [offender, setOffender] = useState(false);
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );
  var today = new Date();

  useEffect(() => {
    loadPersonPermission();
  }, []);

  const loadPersonPermission = () => {
    dispatch(getEmployeeNotificationDetails())
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4016") {
          setIsDrivingLicenseEnabledForAdmin(
            res.data.drivingLicenseEnabledForAdmin,
          );
        }
      });
  };

  useEffect(() => {
    let payload = {
      companyId: decoded_jwtToken.companyId,
    };
    if (decoded_jwtToken.companyType === "CUSTOMER") {
      dispatch(customerSubscription(payload))
        .unwrap()
        .then((res) => {
          if (res.code === "MSGS4032" && res.data) {
            const featureNames = res.data.data.feature.map(
              (feature) => feature.name,
            );
            setFeatureList(featureNames);
          }
        });
    }
  }, []);

  useEffect(() => {
    const normalizedFeatureList = featureList.map((feature) => {
      if (feature === "Checklist") {
        return "Checklist";
      }
      if (feature === "Watchlist") {
        return "Watchlist";
      }
      if (feature === "Offender Verification") {
        return "Offender";
      }
      if (
        feature === "Walk-In Registration through DL & Passport Scanner on Web"
      ) {
        return "Walk-In Registration";
      }
      return feature;
    });
    if (normalizedFeatureList.length !== 0) {
      normalizedFeatureList.forEach((item) => {
        if (
          item === "Walk-In Registration" &&
          isDrivingLicenseEnabledForAdmin &&
          decoded_jwtToken.roleCode === "ADMIN"
        ) {
          setValue("scanLicense");
          setDlScannerPermission(true);
        } else if (
          item === "Walk-In Registration" &&
          decoded_jwtToken.roleCode !== "ADMIN"
        ) {
          setValue("scanLicense");
          setDlScannerPermission(true);
        }
        if (item === "Offender") {
          setOffenderFeature(true);
          setOffender(true);
        }
      });
    }
  }, [featureList]);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };

  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T" +
    (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) +
    ":" +
    (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());

  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    phoneNumber: "",
    phoneCountryCode: "",
    purposeTypeId: "",
    visitorTypeId: "",
    hostId: "",
    visitorCompanyName: "",
    siteId: "",
    scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
    scheduledEndDate: CommonUtil.formatLocalDateTime(
      moment(startDate).add(walkInIntervalTime, "minutes"),
    ),
    visitMode: "WALKIN_REGISTARTION",
    profilePhoto: "",
    documentNumber: "",
    documentExpireDate: "",
    documentFrontImage: "",
    documentRearImage: "",
    verifyTypeIn: "",
    walkInScan: "",
    invitationScan: "",
    selfScan: "",
    address: "",
    remarks: "",
    approvalReason: "",
    printerImage: "",
    documentIssuedDate: "",
    documentScanMode: documentScanMode,
    dateOfBirth: "",
    offenderMatch: false,
  });

  const [offenderPayload, setOffenderpayload] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    city: "",
    state: "",
    zipcode: "",
    lat: 0,
    lng: 0,
    radius: 0,
  });

  const [offenderDataList, setOffenderDataList] = useState([]);

  const [offenderData, setOffenderData] = useState({
    name: "",
    firstName: "",
    firstNameNicknames: [],
    middleName: "",
    lastName: "",
    dob: "",
    address: "",
    city: "",
    state: "",
    zipcode: "",
    sex: "",
    age: "",
    eyeColor: "",
    hairColor: "",
    height: "",
    weight: "",
    race: "",
    ethnicity: "",
    marks: "",
    riskLevel: "",
    crime: "",
    registrationDate: "",
    content: "",
    lat: 0,
    lng: 0,
    offenderUrl: "",
    offenderImageUrl: "",
    offenderImageUrlR2: "",
    jurisdiction: "",
    isAbsconder: false,
    isPredator: false,
    updatedAt: "",
    createdAt: "",
    uuid: "",
    sources: [],
  });

  const [visitorAssetPayload, setVisitorAssetPayload] = useState({
    fileName: "",
    scope: "",
    applicationName: "",
    companyId: localStorage.getItem("companyId"),
  });

  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    emailId: false,
    phoneNumber: false,
    purposeTypeId: false,
    visitorTypeId: false,
    hostId: false,
    visitorCompanyName: false,
    siteId: false,
    profilePhoto: false,
    documentNumber: false,
    documentExpireDate: false,
    approvalReason: false,
    remarks: false,
  });

  const statusDymoService = useDymoCheckService();

  const { statusFetchPrinters, printers } = useDymoFetchPrinters(
    statusDymoService,
  );

  const print = (data) => {
    console.log("Checking connected printers:", printers);

    if (!Array.isArray(printers) || printers.length === 0) {
      return;
    }
    printers.forEach((printer) => {
      try {
        dymo.print(printer.name, data);
        console.log(`Print job sent to ${printer.name}`);
      } catch (error) {
        console.error(`Print failed for ${printer.name}:`, error);
      }
    });
  };

  const onError = (data) => {
    if (data)
      switch (data.code) {
        case "CVAE1015":
          setError({ emailId: true });
          break;
        case "CVAE1016":
          setError({ emailId: true });
          break;
        case "CVAE1012":
          setError({ firstName: true });
          break;
        case "CVAE1013":
          setError({ firstName: true });
          break;
        case "CVAE1017":
          setError({ phoneNumber: true });
          break;
        case "CVAE1050":
          setError({ visitorTypeId: true });
          break;
        case "CVAE1041":
          setError({ purposeTypeId: true });
          break;
        case "CVAE1051":
          setError({ visitorCompanyName: true });
          break;
        case "CVAE1019":
          setError({ hostId: true });
          break;
        case "CVAE1021":
          setError({ scheduledStartDate: true });
          break;
        case "CVAE1022":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE1023":
          setError({ scheduledEndDate: true });
          break;
        case "CVAE0300":
          setError({ siteId: true });
          break;
        default:
          setError({ ...error });
      }
    Toast(data.message, "error");
  };

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.data.profilePhotoURL);
    if (documentScanMode) {
      bodyFormData.append("file", dlImage);
    } else {
      bodyFormData.append("file", profileImage);
    }
    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {})
      .catch(function(response) {});
  };

  const uploadAssetImages = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", assetuploadData.preSignedURL);
    bodyFormData.append("file", data);

    axios({
      method: "post",
      url: "/web/employee/profile",
      data: bodyFormData,
      Authorization: localStorage.getItem("VISJwtToken"),
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function(response) {})
      .catch(function(response) {});
  };

  const handleClose = (data) => {
    clearData();
    props.handleDialogClose();
    if (data.type) {
      handleDeleteAssets();
    }
  };

  const handleDeleteAssets = () => {
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKeys,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const blobToBase64 = (blob) => {
    var reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function() {
      return reader.result;
    };
  };

  const handleSubmit = () => {
    if (!InavalidprofilePhoto) {
      if (profilePhotoMandatory) {
        if (profileImage === undefined || profileImage === "") {
          Toast(t("PROFILE_PHOTO"), "error");
          setError({ profilePhoto: true });
          return;
        }
      }

      if (CommonUtil.isEmptyString(payload.firstName)) {
        Toast(t("USERPROFSCREEN007"), "error");
        setError({ firstName: true });
        return;
      }

      if (!CommonUtil.isValidNames(payload.firstName)) {
        Toast(t("WALKINREPORTLBL2"), "error");
        setError({ firstName: true });
        return;
      }
      if (!autoContactInfo) {
        if (
          CommonUtil.isEmptyString(payload.emailId) &&
          CommonUtil.isEmptyString(payload.phoneNumber)
        ) {
          Toast(t("USERPROFSCREEN014"), "error");
          setError({ emailId: true });
          return;
        }
        if (
          decoded_jwtToken.email === payload.emailId.trim() ||
          payload.emailId.trim() === selectedHost.email
        ) {
          setError({ emailId: true });
          Toast(t("INVITATIONFORM006"), "error");
          return;
        }

        if (
          payload.phoneNumber !== null &&
          payload.phoneNumber !== undefined &&
          payload.phoneNumber !== ""
        ) {
          if (
            userPhone ===
              payload.phoneCountryCode + "-" + payload.phoneNumber ||
            payload.phoneCountryCode + "-" + payload.phoneNumber ===
              selectedHost.phone
          ) {
            setError({ phoneNumber: false });
            Toast(t("INVITATIONFORM009"), "error");
            return;
          }
        }
      }
      if (CommonUtil.isEmpty(selectedHost)) {
        Toast(t("INVITATIONFORM007"), "error");
        setError({ selectedHost: true });
        return;
      }

      if (CommonUtil.isEmpty(payload.siteId)) {
        Toast(t("Site is mandatory"), "error");
        setError({ selectedHost: true });
        return;
      }

      if (
        payload.scheduledStartDate === null ||
        payload.scheduledStartDate === undefined ||
        payload.scheduledStartDate === ""
      ) {
        setError({ scheduledStartDate: true });
        Toast(t("INVITATIONFORM011"), "error");
        return;
      }

      if (
        payload.scheduledEndDate === null ||
        payload.scheduledEndDate === undefined ||
        payload.scheduledEndDate === ""
      ) {
        setError({ scheduledEndDate: true });
        Toast(t("INVITATIONFORM012"), "error");
        return;
      }

      if (scannedDocument) {
        if (payload.documentNumber === "") {
          Toast(t("ENTER_DL_NUMBER"), "error");
          return;
        }
        // if (payload.documentIssuedDate === "") {
        //   Toast(t("ENTER_DL_ISSUE_DATE"), "error");
        //   return;
        // }

        if (payload.documentExpireDate === "") {
          Toast(t("ENTER__DL_EXPIRATION_DATE"), "error");
          return;
        }
        if (
          !passport &&
          payload.documentFrontImage === "" &&
          documentCapturePermission
        ) {
          Toast(t("ENTER_FRONT_IMAGE"), "error");
          return;
        }
        if (
          !passport &&
          payload.documentRearImage === "" &&
          documentCapturePermission
        ) {
          Toast(t("ENTER_REAR_IMAGE"), "error");
          return;
        }
        if (profilePhotoMandatory) {
          if (dlImage === "") {
            Toast(t("PROFILE_PHOTO"), "error");
            return;
          }
        }
      }

      if (
        new Date(payload.scheduledStartDate) <
        new Date(payload.scheduledEndDate)
      ) {
        const dto = {
          firstName: payload.firstName,
          lastName: payload.lastName,
          purposeTypeId: payload.purposeTypeId.id,
          visitorTypeId: payload.visitorTypeId.id,
          hostId: payload.hostId ? payload.hostId : selectedHost.id,
          phoneCountryCode: !CommonUtil.isEmpty(payload.phoneNumber)
            ? payload.phoneCountryCode
            : "",
          phoneNumber: payload.phoneNumber,
          scheduledStartDate: CommonUtil.formatLocalDateTime(
            payload.scheduledStartDate,
          ),
          scheduledEndDate: CommonUtil.formatLocalDateTime(
            payload.scheduledEndDate,
          ),
          emailId: payload.emailId,
          visitMode: payload.visitMode,
          visitorCompanyName: payload.visitorCompanyName,
          siteId: payload.siteId.id,
          siteTimeZone: payload.siteTimeZone,
          documentNumber: payload.documentNumber,
          documentExpireDate: payload.documentExpireDate,
          remarks: payload.remarks,
          approvalReason: payload.approvalReason,
          documentFrontImage: payload.documentFrontImage,
          documentRearImage: payload.documentRearImage,
          profilePhoto: payload.firstName,
          verifyTypeIn: payload.verifyTypeIn,
          invitationScan: payload.invitationScan,
          walkInScan: payload.walkInScan,
          selfScan: payload.selfScan,
          printerImage: printerImage,
          documentIssuedDate: payload.documentIssuedDate,
          documentScanMode: documentScanMode,
          objectKeys: objectKeys,
          offenderFound: offenderFound,
          offenderData: offenderDataList,
          offenderMatch: payload.offenderMatch,
        };

        dispatch(createInvitation(dto))
          .unwrap()
          .then((data) => {
            if (data.code === "CVAI0067") {
              if (confirmationBypass === true && data.data.dymoLabel != null) {
                print(data.data.dymoLabel);
              }
              props.loadData();
              setCurrentTotalVisitCount(data.data.currentVisitCount);
              handleClose(data.data);
              Toast(t("REGSENTSUCC001"), "success");
              if (!CommonUtil.isEmptyString(data.data.profilePhotoURL)) {
                uploadProfilePhoto(data);
              }

              setTimeout(() => {
                props.loadData();
              }, 1000);
              handleClose(false);
            } else {
              onError(data);
            }
          });
      } else {
        Toast(t("INVITATIONFORM003"), "error");
      }
    }
    clearData();
  };

  const titleStyle = {
    color: "#242424",
    opacity: 1,
  };

  useEffect(() => {
    setInavalidprofilePhoto(false);
    loadData(props.open);
  }, []);

  useEffect(() => {
    if (dlScannerPermission) startSentinelSession();
  }, [dlScannerPermission]);

  const loadData = () => {
    loadEmployees();
    loadSites();
    loadVisitorType();
    loadPurposeType();
    loadUser();
    loadCompany();
    loadSetting();
  };

  const loadUser = () => {
    dispatch(getUserInfoPro(decoded_jwtToken.userId))
      .unwrap()
      .then((data) => {
        if (data.code === "UASI0000" || data.code === "UASI0033") {
          setUserPhone(data.data.phone);
        }
      })
      .catch((er) => {});
  };

  const loadVisitorType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getAllVisitorType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setVisitorData(data.data.visitorTypes);
        } else {
          setVisitorData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadPurposeType = () => {
    const query = {
      page: 1,
      rowsPerPage: 1000,
      name: "",
      status: "ACTIVE",
    };

    dispatch(getPurposeType(query))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPurposeData(data.data.purposeTypes);
          setDateChange(true);
        } else {
          setPurposeData([]);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const loadSetting = () => {
    dispatch(getListSettings())
      .unwrap()
      .then((data) => {
        setPayload((prev) => ({
          ...prev,
          verifyTypeIn: data.data.walkInRegistartionVerifyMode,
          walkInScan: data.data.walkInScanLimit,
        }));
        setConfirmationBypass(data.data.badgePrint);
        setWalkInImageCapture(data.data.walkInImageCapture);
        setAutoContactIfo(data.data.walkInAutoContactInfo);
        setDefaultHostId(data.data.defaultWalkInHostId);
      });
  };

  const loadEmployees = (event) => {
    const config = {
      headers: { companyId: localStorage.getItem("companyId") },
    };
    httpCommon
      .unsecuredAxios()
      .get(
        "/web/selfRegistartion/employees/list?sort=createdAt%7Cdesc&caseSensitive=true&operator=AND&pageNumber=1&pageSize=50",
        config,
      )
      .then((data) => {
        if (data.data.code === "OMSI0000") {
          setHostList(data.data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };
  useEffect(() => {
    const defaultHost = hostList.find((host) => host.id === defaultHostId);
    if (defaultHost?.id) {
      setSelectHost(defaultHost);
      setPayload((prev) => ({
        ...prev,
        hostId: defaultHost.id,
      }));
    }
  }, [defaultHostId, hostList]);

  const loadHosts = () => {
    const payload = {
      pageNumber: 1,
      pageSize: 20,
      email: decoded_jwtToken.email,
    };
    dispatch(listHost(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "OMSI0000") {
          getSelectedItem(data.data.employees[0]);
          setHostList(data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };

  const config = {
    headers: { companyId: localStorage.getItem("companyId") },
  };

  const handleText = (event) => {
    httpCommon
      .unsecuredAxios()
      .get(
        "/web/selfRegistartion/employees/list?sort=createdAt%7Cdesc&caseSensitive=true&operator=AND&pageNumber=1&pageSize=0&firstName=" +
          event.target.value +
          "&lastName=" +
          event.target.value,
        config,
      )
      .then((data) => {
        if (data.data.code === "OMSI0000") {
          setHostList(data.data.data.employees);
        } else {
          getSelectedItem();
          setHostList([]);
        }
      });
  };

  const getSelectedItem = (newValue) => {
    if (newValue != null) {
      setPayload((prev) => ({
        ...prev,
        hostId: newValue.id,
      }));
      setSelectHost(newValue);
    } else {
      setPayload((prev) => ({
        ...prev,
        hostId: "",
      }));
      setSelectHost({});
    }
  };
  const loadSites = () => {
    const query = {
      page: 1,
      rowsPerPage: 10000,
      name: "",
    };
    dispatch(getAllSites(query))
      .unwrap()
      .then((data) => {
        if (data.code === "LMSI0000") {
          setSiteData(data.data.site);
        } else {
          setSiteData([]);
        }
      });
  };

  useEffect(() => {
    if (siteData.length === 1) {
      const site = siteData[0];
      setPayload((prev) => ({
        ...prev,
        siteId: site,
        siteTimeZone: site.timeZone ? site.timeZone : "",
      }));
      setError((prev) => ({ ...prev, siteId: false }));
      getSiteCurrentDateTime(site.id);
    }
  }, [siteData]);

  const loadCompany = () => {
    dispatch(getCompanyInfo())
      .unwrap()
      .then((data) => {
        if ((data.code = "UASI0026")) {
          const fullCountryName = data.data.country;
          const countryCode = getCountryCodeFromName(fullCountryName);
          if (countryCode) {
            setCountry(countryCode);
          } else {
            setCountry("us");
          }
        }
      })
      .catch((er) => {});
  };
  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const filterOptions = createFilterOptions({
    stringify: ({ firstName, email }) => `${firstName} ${email}`,
    limit: 1,
  });

  const [setPrivacy, setitPrivacy] = useState(false);
  const [confirmationBypass, setConfirmationBypass] = useState(false);

  const handleChange = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setitPrivacy(event.target.checked);
    setError({
      [name]: false,
    });
  };

  const handleChange1 = (event) => {
    const name = event.target.name;
    setPayload({
      ...payload,
      [name]: event.target.value,
    });
    setError({
      [name]: false,
    });
  };

  const handlePhoneChange = (value, data, event, formattedValue) => {
    setPhoneInput(value);
    setPayload({
      ...payload,
      phoneCountryCode: "+" + data.dialCode,
      phoneNumber: value.toString().replace(data.dialCode, ""),
    });
    setError({ phoneNumber: false });
  };

  const onselectVisitorType = (event) => {
    setPayload({
      ...payload,
      visitorTypeId: event,
    });
  };

  const onselectPurposeType = (event) => {
    setPayload({
      ...payload,
      purposeTypeId: event,
    });
  };

  const setImageFromCam = (image) => {
    if (profilePhotoToggle) {
      setPrinterImage(image);
    }
  };

  const [dlScanner, setDlScanner] = useState(false);
  const [passport, setPassport] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(0);

  const [validatedPhoto, setValidatedPhoto] = useState(false);

  const handleProfile = (file) => {
    setValidatedPhoto(false);
    if (file) {
      const formData = new FormData();
      formData.append("visitorImageFile", file);
      dispatch(validateVisitorImage(formData)).then((res) => {
        if (!res?.payload?.data?.image) {
          setValidatedPhoto(true);
          Toast(t("FACE_DETECTION_ERROR"), "error");
          setProfileImage(null);
          setdlImage(null);
          setImageFromCam("");
          setResetTrigger(Date.now());
          return;
        }
      });
    }
    setValidatedPhoto(false);

    setPayload({
      ...payload,
      profilePhoto: payload?.firstName,
    });
    setProfileImage(validatedPhoto ? "" : file);
    setdlImage(validatedPhoto ? "" : file);
  };

  const handleAddAssets = () => {
    if (objectKeys.length >= props.walkImageCaptureLimit) {
      Toast(t("IMAGE_LIMIT"), "error");
      return;
    }
    let payload = {
      fileName: "VISITOR_ASSET" + assetsImages.length + 1,
      scope: "Application",
      applicationName: "MSGP",
      companyId: localStorage.getItem("companyId"),
    };

    dispatch(uploadVisitorAsset(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4042" && res.data) {
          setAssetUploadData(res.data);
          setWebCam(!webCam);
          setObjectKeys((prevData) => [...prevData, res.data.objectKey]);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const handleDeleteAsset = (index) => {
    let objectKey = objectKeys.filter((_, i) => i == index);
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKey,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
          Toast(t("REMOVE_ASSET_IMAGE"), "success");
          let newImages = assetsImages.filter((_, i) => i !== index);
          setAssetsImages(newImages);
          let newObjectKeys = objectKeys.filter((_, i) => i !== index);
          setObjectKeys(newObjectKeys);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const handleWithOutCaptureImage = () => {
    const index = objectKeys.length - 1;
    let objectKey = objectKeys.filter((_, i) => i == index);
    let payload = {
      fileName: "",
      scope: "",
      applicationName: "",
      companyId: "",
      objectKeys: objectKey,
    };
    dispatch(deteleAssetImage(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4043") {
          let newImages = assetsImages.filter((_, i) => i !== index);
          setAssetsImages(newImages);
          let newObjectKeys = objectKeys.filter((_, i) => i !== index);
          setObjectKeys(newObjectKeys);
        } else {
          Toast(res.message, "error");
        }
      });
  };

  const [value, setValue] = React.useState("manualEntry");
  const [webCampPermssion, setWebCampPermission] = useState(false);
  const { open } = props;
  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };

  const [scannedDocument, setScannedDocument] = useState();
  const sentinelGUID = "eb18e024-22b0-4df0-af18-9cea21942756";

  const startSentinelSession = () => {
    axios.post("http://localhost:10300/sentinel/v1/session/" + sentinelGUID);
  };

  const getScannedData = async () => {
    try {
      const endPoint2 =
        "http://localhost:10300/sentinel/v1/session/" +
        sentinelGUID +
        "/document?api_key=v2";

      const res = await axios.get(endPoint2);

      if (res.data === "") {
        Toast(t("WALKINREPORTLBLDLSCAN"), "info");
        setDlScanner(false);
        return;
      }

      setDocumentScanMode("DOCUMENT_SCANNER_MODE");
      processScannedData(res.data);
      setDisableOffender(false);
    } catch (error) {
      console.error("Error fetching scanned data:", error);
      Toast(t("WALKINREPORTLBLDLSCANERROR"), "info");
    }
  };

  const offenderAuthorizationKey = "AIzaSyDGpRrhZbiHQZnuMyCNUyuNhEKPjzCXgOE";
  const [offenders, setOffenders] = useState([]);
  const [offenderFound, setOffenderFound] = useState(false);
  const [offenderNotFound, setOffenderNotFound] = useState(false);
  const [backGroundVerified, setBackGroundVerified] = useState(false);
  const [disableOffender, setDisableOffender] = useState(true);
  const handleOffenderCheck = () => {
    setDisableOffender(true);
    setBackGroundVerified(true);
    setLoading(true);
    const options = { method: "GET", headers: { accept: "application/json" } };
    fetch(
      "https://api.offenders.io/sexoffender/?key=" +
        offenderAuthorizationKey +
        "&firstName=" +
        payload.firstName +
        "&lastName=" +
        payload.lastName +
        "&dob=" +
        payload.dateOfBirth,
      options,
    )
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        setOffenders(response);
        if (response.offenders.length > 0) {
          setOffenderFound(true);
          setOffenderData(response.offenders[0]);
          setOffenderDataList(response.offenders);
        } else {
          setOffenderNotFound(true);
          setOffenderDataList([]);
        }
      })
      .catch((err) => console.error(err));

    setLoading(false);
  };

  useEffect(() => {
    setDocumentScanMode(documentScanMode);
  }, [documentScanMode]);

  const processScannedData = (data) => {
    setDlScanner(true);
    if (
      !data.Document ||
      !data.Document.DocumentInfo ||
      !data.Document.DocumentInfo.ClassName ||
      data.Document.DocumentInfo.ClassName === "Unknown"
    ) {
      Toast(t("PASSPORT_VALIDATION"), "error");
      return;
    }

    setPassport(
      data.Document.DocumentInfo.ClassName === "Passport" ? true : false,
    );
    setPayload({
      ...payload,
      documentFrontImage:
        "data:image/jpeg;base64," +
        data.Document.Images["Image-Array"][0].DocumentImage.Bitmap[
          "image byte array"
        ],
      documentRearImage:
        "data:image/jpeg;base64," +
        data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
          "image byte array"
        ],
    });

    data.Document.Regions["Region-Array"].map((item) => {
      if (item.DocumentRegion.Name === "Photo") {
        var blob = b64toBlob(
          item.DocumentRegion["Image-Bitmap"].Bitmap["image byte array"],
          "image/jpeg",
        );
        handleProfile(blob);
        setProfileImage(
          "data:image/jpeg;base64," +
            item.DocumentRegion["Image-Bitmap"].Bitmap["image byte array"],
        );
        if (profilePhotoToggle) {
          setPrinterImage(
            item.DocumentRegion["Image-Bitmap"].Bitmap["image byte array"],
          );
        }
      }
    });
    var dateOfBirth = "";
    var documentNumber = "";
    var firstName = "";
    var lastName = "";
    var documentExpireDate = "";
    var address = "";
    var documentIssuedDate = "";
    var documentFrontImage = "";
    var documentRearImage = "";
    var documentFrontImage =
      data.Document.DocumentInfo.ClassName === "Passport"
        ? data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
            "image byte array"
          ]
        : data.Document.Images["Image-Array"][0].DocumentImage.Bitmap[
            "image byte array"
          ];
    var documentRearImage =
      data.Document.DocumentInfo.ClassName === "Passport"
        ? ""
        : data.Document.Images["Image-Array"][1].DocumentImage.Bitmap[
            "image byte array"
          ];

    data.Document.Fields["Field-Array"].map((item) => {
      if (item.DocumentField.Name === "Document Number") {
        documentNumber = item.DocumentField.Value;
      }
      if (item.DocumentField.Name === "Full Name") {
        let name = item.DocumentField.Value;
        let nameParts = name
          .trim()
          .split(" ")
          .filter(Boolean);
        if (nameParts.length === 1) {
          firstName = nameParts[0];
        } else if (nameParts.length === 2) {
          firstName = nameParts[0];
          lastName = nameParts[1];
        } else {
          lastName = nameParts[nameParts.length - 1];
          firstName = nameParts.slice(0, -1).join(" ");
        }
      }

      if (item.DocumentField.Name === "Expiration Date") {
        documentExpireDate = item.DocumentField.Value.split("T")[0];
        let currentDate = new Date().toISOString().split("T")[0];
        if (documentExpireDate < currentDate) {
          Toast("Document Expired", "error");
          return;
        }
      }

      if (item.DocumentField.Name === "Issue Date") {
        documentIssuedDate = item.DocumentField.Value.split("T")[0];
      }

      if (item.DocumentField.Name === "Address") {
        address = item.DocumentField.Value;
      }
      if (item.DocumentField.Name === "Birth Date") {
        dateOfBirth = item.DocumentField.Value.split("T")[0];
      }
    });
    setPayload({
      ...payload,
      documentNumber: documentNumber,
      firstName: firstName,
      lastName: lastName,
      documentExpireDate: documentExpireDate,
      address: address,
      documentIssuedDate: documentIssuedDate,
      documentFrontImage: documentCapturePermission ? documentFrontImage : "",
      documentRearImage: documentCapturePermission ? documentRearImage : "",
      dateOfBirth: dateOfBirth,
    });
    setScannedDocument(data);
  };

  const clearData = () => {
    axios
      .delete("http://localhost:10300/sentinel/v1/session/" + sentinelGUID)
      .then((res) => {
        console.log(res);
      });
  };

  const handeleConfirmBypass = () => {
    setConfirmationBypass(confirmationBypass ? false : true);
    console.log("confirmationBypass", confirmationBypass);
  };

  const purposeTypeToggle = companySettings.walkInRegistrationPurposeType;
  const visitorTypeToggle = companySettings.walkInRegistrationVisitorType;
  const companyNameToggle = companySettings.wlakInRegistrationCompanyName;
  const siteTypeToggle = companySettings.walkInRegistrationSiteType;
  const profilePhotoToggle = companySettings.walkInRegistrationProfilePhoto;
  const purposeTypeMandatory =
    companySettings.checkWalkInRegistrationPurposeType;
  const visitorTypeMandatory =
    companySettings.checkWalkInRegistrationVisitorType;
  const companyNameMandatory =
    companySettings.checkWalkInRegistrationCompanyName;
  const profilePhotoMandatory =
    companySettings.checkWalkInRegistrationProfilePhoto;

  const webCamEnableOrDisable = profilePhotoToggle || documentCapturePermission;

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const handleOptionSelected = (event, value) => {
    if (value) {
      getSelectedItem(value);
      setSelectHost(value);
    } else {
      getSelectedItem();
      setSelectHost();
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setSearchTerm(newInputValue.replace(/\s\s+/g, " "));
  };

  const getSiteCurrentDateTime = (siteId) => {
    httpCommon
      .securedAxios() // swap for whatever instance you actually use for GETs — check what handleText() uses as reference
      .get(`/web/visit/site/${siteId}/currectDateTime`)
      .then((response) => {
        if (
          response?.data?.code === "CVAI0000" &&
          response.data.data?.siteCurrentTime
        ) {
          const startDate = new Date(response.data.data.siteCurrentTime);
          const endOfSameDay = moment(startDate).endOf("day");
          let endDate = moment(startDate).add(walkInIntervalTime, "minutes");
          if (endDate.isAfter(endOfSameDay)) {
            endDate = endOfSameDay;
          }
          setPayload((prev) => ({
            ...prev,
            scheduledStartDate: CommonUtil.formatLocalDateTime(startDate),
            scheduledEndDate: CommonUtil.formatLocalDateTime(endDate),
          }));
          setSiteCurrentDateTime(startDate);
          setSiteTimeEnable(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Dialog
        className={classes.dialogbox}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
            // Adjust the opacity as needed
          },
        }}
      >
        <DialogTitle
          variant="h4"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "black",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {t("WALKINREPORTLBL")}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid container justifyContent="center">
            {loading && (
              <Box sx={{ display: "flex" }} className="loader-container">
                <CircularProgress className="loader" />
              </Box>
            )}
            {webCamEnableOrDisable ? (
              <Grid
                xs={12}
                sm={4}
                container
                justifyContent="center"
                style={{ width: "100%", padding: "45px, 0px" }}
                direction="column"
                alignItems="center"
              >
                {dlScanner ? (
                  <img
                    src={profileImage}
                    alt="Profile"
                    style={{
                      borderStyle: "dashed ",
                      borderRadius: "50%",
                      padding: "5px",
                      color: "#D2D2D2",
                      height: "200px",
                      width: "220px",
                    }}
                    onClick={() => setDlScanner(false)}
                  />
                ) : (
                  <>
                    <WebcamCapture
                      onsetProfile={(profile) => handleProfile(profile)}
                      profilePhoto={profileImage}
                      base64Image={(data) => setImageFromCam(data)}
                      resetTrigger={resetTrigger}
                    />
                  </>
                )}
              </Grid>
            ) : null}

            <Grid
              md={8}
              container
              justifyContent="center"
              style={{ width: "100%" }}
            >
              <Grid sm={12}>
                <TabContext value={value}>
                  <Box sx={{ margin: "20px 0px 0 2px" }}>
                    <TabList
                      onChange={handleChangeTabs}
                      aria-label="lab API tabs example"
                      centered
                      style={{
                        boxShadow: "none",
                        backgroundColor: "transparent",
                        width: "519px",
                        marginLeft: "17px",
                        borderRadius: "10px",
                      }}
                      indicatorColor="none"
                    >
                      <Tab
                        label={t("WALKINREPORTLBLMANUAL")}
                        value="manualEntry"
                        className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
                        style={{ width: "50%" }}
                      />
                      dlScannerPermission
                      {dlScannerPermission ? (
                        <Tab
                          label={t("WALKINREPORTLBLSCANLICENCE")}
                          value="scanLicense"
                          className={darkMode ? "tabStyleReg1" : "tabStyleReg"}
                          style={{ width: "50%" }}
                        />
                      ) : (
                        ""
                      )}
                    </TabList>
                    <TabPanel
                      value="manualEntry"
                      style={{
                        paddingBottom: "0px",
                      }}
                    >
                      <Grid container sm={12} columnSpacing={2} rowSpacing={3}>
                        <Grid item lg={6} sm={12}>
                          <CustomTextfield
                            label={t("COMMON020")}
                            error={error.firstName}
                            name="firstName"
                            value={payload.firstName}
                            handleChange={(e) => handleChange(e)}
                            helperText={error.firstName}
                            required={true}
                            autoComplete="off"
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        <Grid item lg={6} sm={12}>
                          <CustomTextfield
                            label={t("COMMON021")}
                            error={error.lastName}
                            name="lastName"
                            value={payload.lastName}
                            handleChange={(e) => handleChange(e)}
                            helperText={error.lastName}
                            autoComplete="off"
                            inputProps={{ className: classes.input }}
                          />
                        </Grid>

                        {scannedDocument ? (
                          <Grid item lg={6} sm={12}>
                            <CustomTextfield
                              label={passport ? "DL/Passport No" : "DL No"}
                              error={error.documentNumber}
                              name="documentNumber"
                              value={payload.documentNumber}
                              handleChange={(e) => handleChange(e)}
                              disabled
                            />
                          </Grid>
                        ) : null}

                        {scannedDocument ? (
                          <Grid item lg={6} sm={12}>
                            <CustomTextfield
                              label={"Expired Date *"}
                              error={error.documentExpireDate}
                              name="documentExpireDate"
                              value={payload.documentExpireDate}
                              handleChange={(e) => handleChange(e)}
                              disabled
                            />
                          </Grid>
                        ) : null}

                        {!autoContactInfo ? (
                          <Grid item lg={6} sm={12}>
                            <CustomTextfield
                              label={t("COMMON042")}
                              error={error.emailId}
                              name="emailId"
                              value={payload.emailId}
                              handleChange={(e) => handleChange(e)}
                              helperText={error.emailId}
                              validation="email"
                              autoComplete="off"
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {!autoContactInfo ? (
                          <Grid item lg={6} sm={12}>
                            <CustomPhones
                              placeholder={t("COMMON063")}
                              value={phoneInput}
                              specialLabel={false}
                              country={country}
                              handleChange={(
                                value,
                                data,
                                event,
                                formattedValue,
                              ) =>
                                handlePhoneChange(
                                  value,
                                  data,
                                  event,
                                  formattedValue,
                                )
                              }
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        ) : (
                          ""
                        )}

                        {purposeTypeToggle ? (
                          <Grid item lg={6} sm={12}>
                            <Autocomplete
                              popupIcon={<ExpandMoreIcon />}
                              sx={{
                                width: "100%",
                              }}
                              noOptionsText={"No Options found"}
                              name="purposeTypeId"
                              value={payload.purposeTypeId}
                              options={
                                CommonUtil.isEmptyArray(purposeData)
                                  ? []
                                  : purposeData
                              }
                              getOptionLabel={(option) =>
                                option.name ? option.name : ""
                              }
                              onChange={(event, newValue) => {
                                if (!CommonUtil.isEmpty(newValue)) {
                                  onselectPurposeType(newValue);
                                } else {
                                  onselectPurposeType("");
                                }
                                setError({ purposeTypeId: false });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required={purposeTypeMandatory ? true : false}
                                  name="purposeTypeId"
                                  value={payload.purposeTypeId}
                                  error={error.purposeTypeId}
                                  variant="outlined"
                                  fullWidth
                                  label={t("PURPOSELABEL1")}
                                />
                              )}
                            />
                          </Grid>
                        ) : null}

                        {visitorTypeToggle ? (
                          <Grid item lg={6} sm={12}>
                            <Autocomplete
                              popupIcon={<ExpandMoreIcon />}
                              sx={{}}
                              noOptionsText={"No Options found"}
                              name="visitorTypeId"
                              value={payload.visitorTypeId}
                              options={
                                CommonUtil.isEmptyArray(visitorData)
                                  ? []
                                  : visitorData
                              }
                              getOptionLabel={(option) =>
                                option.name ? option.name : ""
                              }
                              onChange={(event, newValue) => {
                                if (!CommonUtil.isEmpty(newValue)) {
                                  onselectVisitorType(newValue);
                                } else {
                                  onselectVisitorType("");
                                }
                                setError({ visitorTypeId: false });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="visitorTypeId"
                                  required={visitorTypeMandatory ? true : false}
                                  value={payload.visitorTypeId}
                                  error={error.visitorTypeId}
                                  variant="outlined"
                                  fullWidth
                                  label={t("COMMON068")}
                                />
                              )}
                            />
                          </Grid>
                        ) : null}

                        <Grid item lg={6} sm={12}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            sx={{
                              color: "#242424",
                              "& .MuiAutocomplete-clearIndicator": {
                                color: "#949596",
                              },
                              "& .MuiSvgIcon-root": {
                                color: "#949596",
                              },
                            }}
                            id="free-solo-demo"
                            freeSolo
                            noOptionsText={"No Options found"}
                            fullWidth
                            value={selectedHost}
                            filterOptions={filterOptions}
                            onChange={(event, newValue) => {
                              handleOptionSelected(event, newValue);
                              setError({ selectedHost: false });
                            }}
                            inputValue={searchTerm}
                            onInputChange={handleInputChange}
                            options={hostList}
                            disabled={decoded_jwtToken.roleName === "Employee"}
                            // filterOptions={filterOptions}
                            getOptionLabel={(option) =>
                              option.lastName
                                ? option.firstName + " " + option.lastName
                                : option.firstName
                                ? option.firstName
                                : ""
                            }
                            renderInput={(params) => (
                              <CustomTextfield
                                {...params}
                                label={t("commonsTextFeildHost")}
                                placeholder={t("commonsTextFeildHost")}
                                error={error.selectedHost}
                              />
                            )}
                          />
                        </Grid>

                        {companyNameToggle ? (
                          <Grid item lg={6} xs={12}>
                            <CustomTextfield
                              required={companyNameMandatory ? true : false}
                              label={t("VISUPDATE0006")}
                              error={error.visitorCompanyName}
                              name="visitorCompanyName"
                              value={payload.visitorCompanyName}
                              handleChange={(e) => handleChange(e)}
                              helperText={error.visitorCompanyName}
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        ) : null}

                        <Grid item lg={6} sm={12}>
                          <Autocomplete
                            popupIcon={<ExpandMoreIcon />}
                            sx={{ width: "100%" }}
                            noOptionsText={"No Options found"}
                            name="siteId"
                            value={payload.siteId}
                            disabled={siteData.length === 1}
                            options={
                              CommonUtil.isEmptyArray(siteData) ? [] : siteData
                            }
                            getOptionLabel={(option) =>
                              option.name ? option.name : ""
                            }
                            onChange={(event, newValue) => {
                              if (!CommonUtil.isEmpty(newValue)) {
                                setPayload((prev) => ({
                                  ...prev,
                                  siteId: newValue,
                                  siteTimeZone: newValue.timeZone
                                    ? newValue.timeZone
                                    : "",
                                }));

                                getSiteCurrentDateTime(newValue.id);
                              } else {
                                setPayload((prev) => ({
                                  ...prev,
                                  siteId: "",
                                  siteTimeZone: "",
                                }));

                                setSiteTimeEnable(true);
                                setSiteCurrentDateTime(null);
                              }

                              setError((prev) => ({
                                ...prev,
                                siteId: false,
                              }));
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="siteId"
                                required={true}
                                error={error.siteId}
                                variant="outlined"
                                fullWidth
                                label={t("SITE013")}
                              />
                            )}
                          />
                        </Grid>

                        {/* {siteTypeToggle && (
                          <Grid item xs={12}>
                            <Typography
                              variant="caption"
                              style={{
                                color: darkMode ? "#9aa5b1" : "#6b7280",
                              }}
                            >
                              {siteTimeEnable
                                ? t(
                                    "Select a site above to enable the start and end date & time — they will be pre-filled with that site's current local time.",
                                  )
                                : t(
                                    "Start and end date & time are shown in the selected site's local time zone.",
                                  )}
                            </Typography>
                          </Grid>
                        )} */}

                        <Grid item lg={6} xs={12}>
                          <CustomDateTimePicker
                            onChange={(scheduledStartDate) =>
                              setPayload({
                                ...payload,
                                scheduledStartDate: CommonUtil.formatLocalDateTime(
                                  scheduledStartDate,
                                ),
                                scheduledEndDate: CommonUtil.formatLocalDateTime(
                                  moment(scheduledStartDate).add(
                                    walkInIntervalTime,
                                    "minutes",
                                  ),
                                ),
                              })
                            }
                            minDateTime={siteCurrentDateTime}
                            maxDateTime={siteCurrentDateTime}
                            value={payload.scheduledStartDate}
                            label={t("INVITESTARTDATEERROR1")}
                            changeDate={changeDate}
                            date={props.date}
                            disabled={siteTimeEnable}
                          />
                        </Grid>

                        <Grid item lg={6} xs={12}>
                          <CustomDateTimePicker
                            onChange={(scheduledEndDate) =>
                              setPayload({
                                ...payload,
                                scheduledEndDate: CommonUtil.formatLocalDateTime(
                                  scheduledEndDate,
                                ),
                              })
                            }
                            value={payload.scheduledEndDate}
                            minDateTime={
                              payload.scheduledStartDate
                                ? new Date(payload.scheduledStartDate)
                                : undefined
                            }
                            maxDateTime={
                              siteCurrentDateTime
                                ? moment(siteCurrentDateTime)
                                    .endOf("day")
                                    .toDate()
                                : undefined
                            }
                            label={t("INVITESTARTDATEERROR2")}
                            changeDate={changeDate}
                            date={props.date}
                            disabled={siteTimeEnable}
                          />
                        </Grid>

                        {scannedDocument ? (
                          <Grid item lg={6} xs={12}>
                            <CustomTextfield
                              label="Address"
                              error={error.address}
                              name="address"
                              value={payload.address}
                              handleChange={(e) => handleChange(e)}
                              helperText={error.address}
                              validation="alphabets"
                              inputProps={{ className: classes.input }}
                            />
                          </Grid>
                        ) : null}

                        {scannedDocument ? (
                          <Grid
                            item
                            lg={
                              (Number(!purposeTypeToggle) +
                                Number(!visitorTypeToggle) +
                                Number(!companyNameToggle) +
                                Number(!siteTypeToggle)) %
                                2 ===
                              1
                                ? 6
                                : 12
                            }
                            sm={12}
                          >
                            <CustomTextfield
                              label={t("COMMON016")}
                              error={error.approvalReason}
                              name="approvalReason"
                              value={payload.approvalReason}
                              validation="restrictLength"
                              handleChange={(e) => handleChange(e)}
                              helperText={error.remarks}
                              inputProps={{
                                maxLength: 100,
                                className: classes.input,
                              }}
                            />
                          </Grid>
                        ) : (
                          <Grid
                            item
                            lg={
                              (Number(!purposeTypeToggle) +
                                Number(!visitorTypeToggle) +
                                Number(!companyNameToggle) +
                                Number(!siteTypeToggle)) %
                                2 ===
                              1
                                ? 12
                                : 6
                            }
                            sm={12}
                          >
                            <CustomTextfield
                              label={t("COMMON016")}
                              error={error.approvalReason}
                              name="approvalReason"
                              value={payload.approvalReason}
                              handleChange={(e) => handleChange(e)}
                              validation="restrictLength"
                              helperText={error.approvalReason}
                              inputProps={{
                                maxLength: 100,
                                className: classes.input,
                              }}
                            />
                          </Grid>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          spacing={3}
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "flex-start",
                            columnGap: "15px",
                          }}
                        >
                          {assetsImages.map((imageSrc, index) => (
                            <div
                              key={index}
                              style={{ position: "relative" }}
                              onMouseEnter={() => setHoveredIndex(index)}
                              onMouseLeave={() => setHoveredIndex(null)}
                            >
                              <img
                                key={index}
                                src={imageSrc}
                                alt={`Image ${index + 1}`}
                                height="60"
                                width="60"
                              />

                              {hoveredIndex === index && (
                                <Tooltip title={t("REMOVE_ASSET")}>
                                  <CloseIcon
                                    key={index}
                                    style={{
                                      position: "absolute",
                                      right: "-10px",
                                      top: "-10px",
                                      backgroundColor: "#DDDDDD",
                                      borderRadius: "50px",
                                      height: "17px",
                                      width: "17px",
                                    }}
                                    onClick={() => handleDeleteAsset(index)}
                                  />
                                </Tooltip>
                              )}
                            </div>
                          ))}
                          {walkInImageCapture && assetsImages.length < 5 && (
                            <Tooltip title={t("ADD_ASSET")}>
                              <img
                                src={cameraIcon}
                                alt="Invalid Icon"
                                onClick={handleAddAssets}
                                height="30"
                                width="30"
                              />
                            </Tooltip>
                          )}
                        </Grid>
                      </Grid>

                      <DialogActions
                        style={{
                          justifyContent: "center",
                        }}
                      >
                        <CancelButtons
                          variant="contained"
                          color="secondary"
                          onClick={handleClose}
                        >
                          <Typography
                            variant="body1"
                            style={{ textTransform: "none" }}
                          >
                            {t("INVITATION003")}
                          </Typography>
                        </CancelButtons>
                        <SubmitButtons
                          variant="contained"
                          onClick={handleSubmit}
                        >
                          <Typography
                            variant="body1"
                            style={{ textTransform: "none" }}
                          >
                            {t("COMMON035")}
                          </Typography>
                        </SubmitButtons>
                      </DialogActions>
                    </TabPanel>

                    {dlScannerPermission && (
                      <TabPanel value="scanLicense">
                        {props.showDLScan ? (
                          <Grid
                            style={{ textAlign: "end", marginRight: "10px" }}
                          >
                            {payload.documentFrontImage !== "" ? (
                              <SubmitButtons
                                variant="contained"
                                disabled
                                onClick={() => {
                                  getScannedData();
                                }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{ textTransform: "none" }}
                                >
                                  {t("WALKINREPORTLBLDL")}
                                </Typography>
                              </SubmitButtons>
                            ) : (
                              <SubmitButtons
                                variant="contained"
                                onClick={() => {
                                  getScannedData();
                                }}
                                style={{ height: "44px" }}
                              >
                                <Typography
                                  variant="body1"
                                  style={{ textTransform: "none" }}
                                >
                                  {t("WALKINREPORTLBLDL")}
                                </Typography>
                              </SubmitButtons>
                            )}
                          </Grid>
                        ) : (
                          ""
                        )}
                        <Grid
                          container
                          sm={12}
                          spacing={1}
                          style={{ paddingTop: "11px" }}
                        >
                          {documentCapturePermission && (
                            <Grid item lg={6} sm={12}>
                              <UploadDocs
                                imageName={t("WALKINREPORTLBLCAPT")}
                                profilePhoto={
                                  scannedDocument
                                    ? passport
                                      ? "data:image/jpeg;base64," +
                                        scannedDocument.Document.Images[
                                          "Image-Array"
                                        ][1].DocumentImage.Bitmap[
                                          "image byte array"
                                        ]
                                      : "data:image/jpeg;base64," +
                                        scannedDocument.Document.Images[
                                          "Image-Array"
                                        ][0].DocumentImage.Bitmap[
                                          "image byte array"
                                        ]
                                    : ""
                                }
                              />
                            </Grid>
                          )}

                          <Grid item lg={6} sm={12}>
                            {documentCapturePermission && !passport && (
                              <UploadDocs
                                imageName={t("WALKINREPORTLBLCAPTBCK")}
                                profilePhoto={
                                  scannedDocument
                                    ? "data:image/jpeg;base64," +
                                      scannedDocument.Document.Images[
                                        "Image-Array"
                                      ][1].DocumentImage.Bitmap[
                                        "image byte array"
                                      ]
                                    : ""
                                }
                              />
                            )}
                          </Grid>

                          {documentCapturePermission &&
                            offenderFeature &&
                            offenderVerification && (
                              <Grid
                                style={{
                                  padding: "6px",
                                }}
                              >
                                <SubmitButtons
                                  disabled={
                                    disableOffender ||
                                    payload.documentFrontImage === ""
                                  }
                                  variant="contained"
                                  onClick={() => {
                                    handleOffenderCheck();
                                  }}
                                >
                                  <Typography
                                    variant="body1"
                                    style={{
                                      textTransform: "none",
                                      color: darkMode
                                        ? "rgb(205, 205, 205)"
                                        : "",
                                    }}
                                  >
                                    {t("OFFENDER")}
                                  </Typography>
                                </SubmitButtons>
                              </Grid>
                            )}
                          {backGroundVerified && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#e6ffe6",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={successIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#6BC88E",
                                    marginTop: "10px",
                                  }}
                                >
                                  Background Verified
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                          {offenderNotFound && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#e6ffe6",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={successIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#6BC88E",
                                    marginTop: "10px",
                                  }}
                                >
                                  No Offender Record Found
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                          {offenderFound && (
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              md={12}
                              lg={12}
                              xl={12}
                              style={{
                                height: "60px",
                                width: "100%",
                                backgroundColor: "#FFEAEB",
                                borderRadius: "10px",
                                marginTop: "10px",
                              }}
                            >
                              <Stack
                                direction="row"
                                spacing={2}
                                style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={errorIcon}
                                  alt="success"
                                  style={{
                                    marginLeft: "15px",
                                    marginTop: "8px",
                                  }}
                                />
                                <Typography
                                  style={{
                                    color: "#FF4D50",
                                    marginTop: "10px",
                                  }}
                                >
                                  Offender Record Found
                                </Typography>
                              </Stack>
                            </Grid>
                          )}
                        </Grid>
                        <DialogActions
                          style={{
                            justifyContent: "flex-end",
                          }}
                        >
                          <SubmitButtons
                            variant="contained"
                            onClick={() => {
                              if (documentCapturePermission) {
                                if (!payload.documentFrontImage) {
                                  Toast(t("DOCUMENT_SCANNER_ERROR"), "error");
                                  return;
                                }
                                if (!passport && !payload.documentRearImage) {
                                  Toast(t("DOCUMENT_SCANNER_ERROR"), "error");
                                  return;
                                }
                              }
                              setValue("manualEntry");
                            }}
                          >
                            <Typography
                              variant="body1"
                              style={{ textTransform: "none" }}
                            >
                              {t("VERIFYCOMP0003")}
                            </Typography>
                          </SubmitButtons>
                        </DialogActions>
                      </TabPanel>
                    )}
                  </Box>
                </TabContext>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        {webCam && (
          <VisitorAssetsDialog
            open={webCam}
            handleClose={() => {
              handleWithOutCaptureImage();
              setWebCam(!webCam);
            }}
            content={assetuploadData}
            handleSubmit={(blob, base64Data, content) => {
              setAssetsImages((prevImages) => [...prevImages, base64Data]);
              uploadAssetImages(blob);
              setWebCam(!webCam);
              Toast(t("ASSET_SUCCESSFULLY"), "success");
            }}
          />
        )}
        {offenderFound && (
          <Offender
            visitorDLData={offenderData}
            visitorDLImage={profileImage}
            data={offenderData}
            open={offenderFound}
            handleMatch={() => {
              setPayload({
                ...payload,
                offenderMatch: true,
              });
              setOffenderFound(false);
            }}
            handleCloseMatch={() => {
              setPayload({
                ...payload,
                offenderMatch: false,
              });
              setOffenderFound(false);
            }}
          />
        )}
      </Dialog>
    </>
  );
}
